import { useServices } from '../../../services/useServices';
import { AzureMLKey } from '../pipelines.model';
import { usePipelineQuery } from './usePipelineQuery';

export const useAzureMLPipeline = (key: AzureMLKey, history = 10) => {
  const { pipelines } = useServices();

  return usePipelineQuery(
    ['pipelines', 'azureml', key, history],
    () => pipelines.getAzureMLPipeline(key, history)
  );
};
